




















import { Component, Vue, Prop } from 'vue-property-decorator'

import Breadcrumbs, { Crumb } from './Breadcrumbs.vue'

@Component({
  components: {
    Breadcrumbs
  }
})
export default
class PageHeader extends Vue {
  @Prop({ required: false }) readonly crumbs?: Crumb[]
  @Prop({ required: false }) readonly title!: string
}
